import { defineStore, storeToRefs } from 'pinia';
import usePageDataStore from '~/stores/usePageData';
import useEnvProps from '~/stores/useEnvProps';
import { reviewsReqService, newReviewsReqService } from '~/modules/reviews/services/ReviewService';

const useReviewsServiceStore = defineStore('reviewsServiceStore', () => {
  const { pageData } = storeToRefs(usePageDataStore());
  const { envProps } = storeToRefs(useEnvProps());
  const reqFunc = pageData.value?.killswitches?.isCacheControlInResponseHeaderEnabled ? newReviewsReqService : reviewsReqService;

  function reviewRequestService(args: object) {
    return reqFunc({
      hostlink: envProps.value.hostlink,
      ...args,
    });
  }

  return {
    // Actions
    reviewRequestService,
  };
});

export default useReviewsServiceStore;
